import { CopyIconButton } from '@mi-front/ui';
import { Box, Typography } from '@mui/material';

/**
 * Device id with a compact copy-to-clipboard control.
 */
export function BalenaDeviceIdCopyButton({ deviceId }: { deviceId: number }) {
  const idAsString = String(deviceId);

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25 }}>
      <Typography
        variant="caption"
        color="text.disabled"
        sx={{ fontVariantNumeric: 'tabular-nums' }}
      >
        #{deviceId}
      </Typography>
      <CopyIconButton
        copyValue={idAsString}
        iconFontSize={12}
        sx={{
          p: 0.25,
          color: 'text.disabled',
          '&:hover': { color: 'text.secondary' },
        }}
      />
    </Box>
  );
}
